import cn from 'classnames';
import React from 'react';
import { useFilingContext } from '@/finsight/application/Filings/FilingsContext';
import TableWrapper from '@/finsight/ui/components/filings/TableWrapper';
import { BodyWrapper, dataTableStyles } from '@dealroadshow/uikit/core/components/Table/DataTable';
import { DEFAULT_EMPTY_MESSAGE } from '@/Framework/UI/Molecules/Tables/constants';
import TableRow from './TableRow';
import TableHeader, { COLUMNS } from './TableHeader';
import Paginator from './PaginatorContainer';

import loanLevelTableStyles from './loanLevelTable.scss';
import spacesStyles from '@dealroadshow/uikit/core/styles/helpers/spaces.scss';

const LoanLevelTable = () => {
  const {
    collection,
    isFetching,
    totalCount,
  } = useFilingContext();

  const emptyMessageClass = cn(
    dataTableStyles.emptyMessage,
    loanLevelTableStyles.emptyMessage,
    spacesStyles.ptxl,
    spacesStyles.pbxl,
  );

  const renderContent = () => {
    if (totalCount === 0) {
      return (
        <tr className={ emptyMessageClass }>
          <td colSpan={ COLUMNS.length }>
            { isFetching ? '' : DEFAULT_EMPTY_MESSAGE }
          </td>
        </tr>
      );
    }

    return Object.keys(collection)
      .map((filingIndex) => {
        const key = parseInt(filingIndex);
        return (
          <TableRow
            key={ key }
            filingIndex={ key }
          />
        );
      });
  };

  return (
    <>
      <TableWrapper showSpinner={ isFetching }>
        <TableHeader />
        <BodyWrapper>
          { renderContent() }
        </BodyWrapper>
      </TableWrapper>
      <Paginator
        className={ spacesStyles.pl }
        dataTest="loanLevelHeader"
      />
    </>
  );
};

export default LoanLevelTable;
